export default __webpack_public_path__ + "images/1ff7a20c5055652bc78bcf19e0a2965c-no-pets.svg";